export const stringListToSelectOption = (el: string) => ({
  label: el,
  value: el,
});
